import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Row, Col } from 'reactstrap';
import { formatPriceStringV2 } from 'site-modules/shared/utils/price-utils';
import dateFormat from 'dateformat';

export function AppraisalReportStepDescription({ descriptionValues = [] }) {
  const sectionsWithAdditionalClass = ['Exterior'];
  const appraisalDate = dateFormat(Date.now(), 'shortDate');

  return descriptionValues.map(({ title: valueTitle, value, isTotal }) => (
    <Row key={valueTitle} className={classNames({ 'mb-0_75': isTotal })}>
      <Col
        className={classNames({
          'text-gray small': !isTotal,
          'text-gray-darker fw-bold': isTotal,
        })}
        xs={6}
      >
        {valueTitle}
      </Col>
      <Col
        className={classNames('text-end', {
          'text-gray small': !isTotal,
          'text-gray-darker fw-bold': isTotal,
          'color-name-selection': sectionsWithAdditionalClass.includes(valueTitle),
        })}
        xs={6}
      >
        {isTotal ? (
          <Fragment>
            {formatPriceStringV2(value)}
            <div className="appraisal-date fw-normal mt-0_25">{`As of ${appraisalDate}`}</div>
          </Fragment>
        ) : (
          value
        )}
      </Col>
    </Row>
  ));
}

AppraisalReportStepDescription.propTypes = {
  descriptionValues: PropTypes.arrayOf(PropTypes.shape({})),
};
